import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage, FormikHelpers } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { sendNotification } from "../../../services/notification.service";
import VisibilityBox from "../../../components/common/VisibilityBox";
import { IEmployee } from "../../../interfaces/employee.interface";
import { getEmployeesForDevices } from "../../../services/employee.service";
import { Icon } from "@iconify/react";

const validationSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  body: Yup.string().required("Body is required"),
  isAll: Yup.bool().required("Is All is required"),
});

const Notification = () => {
  const [employees, setEmployees] = useState<IEmployee[]>([]);
  const [selectedEmployees, setSelectedEmployees] = useState<IEmployee[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const employeesData = await getEmployeesForDevices();
      setEmployees(employeesData.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <section>
      <div className="d-flex justify-content-between">
        <h2 className="title">Notification</h2>
      </div>
      {/* Formik Form */}
      <Formik
        initialValues={{
          title: "",
          body: "",
          deviceIds: [],
          isAll: false,
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={async (values, { resetForm }: FormikHelpers<any>) => {
          const result = await sendNotification(values);
          setSelectedEmployees([]);
          resetForm();
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          resetForm,
          setFieldValue,
        }) => (
          <Form>
            {/* Full Name */}
            <div className="form-group p-0 mb-3">
              <Field
                id="title"
                name="title"
                type="text"
                placeholder="Title"
                className={`form-control ${
                  errors.title && touched.title ? "is-invalid" : ""
                }`}
              />
              <ErrorMessage
                name="title"
                component="div"
                className="invalid-feedback"
              />
            </div>

            <div className="form-group p-0 mb-3">
              <textarea
                id="body"
                name="body"
                placeholder="Description ..."
                className={`form-control ${
                  errors.body && touched.body ? "is-invalid" : ""
                }`}
                value={values?.body}
                onChange={handleChange}
                rows={10}
              />
              <ErrorMessage
                name="body"
                component="div"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group d-flex p-0 mb-3">
              <Field
                id="title"
                name="isAll"
                type="checkbox"
                className={`form-check ${
                  errors.isAll && touched.isAll ? "is-invalid" : ""
                }`}
              />
              <label className="mx-2">Send To All Employee</label>
              <ErrorMessage
                name="isAll"
                component="div"
                className="invalid-feedback"
              />
            </div>
            <VisibilityBox show={values?.isAll == false}>
              <div className="col-md-12 col-sm-12 mb-2 p-0">
                <div className="d-flex flex-wrap gap-2 px-1">
                  {selectedEmployees.map((d: any, dIx: number) => (
                    <span key={dIx} className="badge bg-primary p-2">
                      {d?.fullName}
                      <Icon
                        icon="material-symbols:close-rounded"
                        className="cursor-pointer ms-1"
                        onClick={() => {
                          const updated = selectedEmployees.filter(
                            (_, i) => i !== dIx
                          );
                          setSelectedEmployees(updated);
                          setFieldValue(
                            "deviceIds",
                            updated.map((d) => d?.deviceToken)
                          ); // update form field
                        }}
                      />
                    </span>
                  ))}
                </div>
              </div>
              <div className="col-md-12 col-sm-12 mb-3 p-0">
                <div className="form-group p-0">
                  <select
                    id="distributor"
                    name="distributors"
                    className={`form-control ${
                      errors.distributors && touched.distributors
                        ? "is-invalid"
                        : ""
                    }`}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selected = employees.find(
                        (item) => item.deviceToken === selectedId
                      );
                      if (
                        selected &&
                        !selectedEmployees.some((d) => d.deviceToken === selectedId)
                      ) {
                        const updated = [...selectedEmployees, selected];
                        setSelectedEmployees(updated);
                        setFieldValue(
                          "deviceIds",
                          updated.map((d) => d.deviceToken)
                        );
                      }
                    }}
                    value=""
                  >
                    <option value="" disabled>
                      Select Employee
                    </option>
                    {employees.map((item) => (
                      <option key={item._id} value={item.deviceToken}>
                        <div className="d-flex justify-content-between w-100">
                          <span>{item.fullName} </span>
                          <span> ({item?.address?.city}, {item?.address?.state})</span>
                        </div>
                      </option>
                    ))}
                  </select>
                  <ErrorMessage
                    name="deviceIds"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
            </VisibilityBox>

            <div className="d-flex mt-4">
              <button type="submit" className="btn btn-primary px-4">
                Send Notification
              </button>
              <button
                type="reset"
                onClick={() => resetForm()}
                className="btn btn-danger mx-4"
              >
                Reset
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default Notification;
